import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { DateRangeUnindexComponent } from '../../components/date-range-unindex/date-range-unindex.component';
import { RoleTypeComponent } from '../../components/role-type/role-type.component';
import { NgForm, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import * as CompoundNameActions from '../../../store/actions/compoundname.action';
import * as RoleTypeActions from '../../../store/actions/roletype.action'; 
import { UnindexSearchService } from '../../unindexed-search-service';
import { IndexVM } from '../../../shared/viewmodels/ISearchServiceReg';
import { CompoundNameIdxComponent } from '../../../shared/components/compound-name-idx/compound-name-idx.component';

@Component({
  selector: 'app-unindexed-record-search',
  providers: [UnindexSearchService],
  templateUrl: './unindexed-record-search.component.html',
  styleUrls: ['./unindexed-record-search.component.css']
})
export class UnindexedRecordSearchComponent implements OnInit {

  @ViewChild(CompoundNameIdxComponent, { static: false }) compoundNameChild;
  @ViewChild(DateRangeUnindexComponent, { static: false }) dateRangeChild;
  @ViewChild(RoleTypeComponent, { static: false }) roleChild;
  
  @ViewChild('f', { static: true }) unindexSearchForm: NgForm;
  parentForm: UntypedFormGroup;
  results: IndexVM[] = [];
  error: any;
  img: string;
  majorgroup: string;
  fnameShow: boolean=true;
  screenWidth: any;

  ngOnInit() {
    this.getScreenSize();
    this.majorgroup = this.route.snapshot.paramMap.get('majorgroup');
    if (this.majorgroup === "1800-1854")
      this.fnameShow = false;
    this.parentForm = this.fb.group({
    });

/*    this.unindexSearchForm.form = this.fb.group({});*/

  }



  constructor(private router: Router, private store: Store<AppState>, private fb: UntypedFormBuilder, private service: UnindexSearchService, private route: ActivatedRoute) {

    
  }

  
  addRecToStore(fname, lname) {
    this.store.dispatch(new CompoundNameActions.AddName({
      fName: fname,
      lastcorpName: lname
    }))

    
  }

  /**
   * Delete input parameters from store.
   * @param index
   */
  delRecFromStore(index) {
    //this.store.dispatch(new RecActions.RemoveRec(index));
    this.store.dispatch(new CompoundNameActions.RemoveName(index));
    this.store.dispatch(new RoleTypeActions.RemoveRoleType(index));
  }

  
  onSubmit(e) {
    if (this.unindexSearchForm.valid) {

      this.delRecFromStore(0);

      this.addRecToStore(
        this.compoundNameChild.utilityobj.fName,
        this.compoundNameChild.utilityobj.lastcorpName
        );
      this.getResults();
      
      
       
      console.log("date" + this.dateRangeChild.selectedDate);

    }
    else {
      this.validateAllFormFields(this.unindexSearchForm.form);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof UntypedFormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  ngAfterViewInit() {

    this.unindexSearchForm.form = this.fb.group({});
    
    this.unindexSearchForm.form.addControl('compoundNameForm', this.compoundNameChild.form);
    this.compoundNameChild.form.setParent(this.unindexSearchForm.form);

    //this.unindexSearchForm.form.addControl('dateRangeForm', this.dateRangeChild.form);
    //this.dateRangeChild.form.setParent(this.unindexSearchForm.form);
  }

  getResults() {
    this.service.GetUnindexedSearchResults(this.compoundNameChild.utilityobj.lastcorpName, this.compoundNameChild.utilityobj.fName, this.dateRangeChild.dategroup).subscribe(
      data => {
        this.results = data
      },
      error => { this.error = error }
    );
  }

 

  //ItemClick(event) {
  //  this.router.navigate(['/unindexed-record-doc-disp-pg', this.results[0].indexBook, this.results[0].indexGroup, this.results[0].indexPage, this.results[0].dateGroup]);
  //}

  ItemClick(e) {
    if (e === null) {
      console.log('ItemClick fired and event is null');
    }
    else {
      console.log(`ItemClick fired: ${e.itemData}`);
      
     // this.router.navigate(['/unindexed-record-doc-disp-pg', e.itemData.indexBook, e.itemData.indexGroup, e.itemData.indexPage, e.itemData.dateGroup]);
      var thisURL = '';
      //thisURL = window.location.pathname.replace('unindexed-record-search1', 'unindexed-record-doc-disp-pg');
      //thisURL = window.location.pathname.replace('unindexed-record-search2', 'unindexed-record-doc-disp-pg');
      //thisURL = window.location.pathname.replace('unindexed-record-search3', 'unindexed-record-doc-disp-pg');
      //thisURL = window.location.pathname.replace('unindexed-record-search4', 'unindexed-record-doc-disp-pg');
      //thisURL = window.location.pathname.replace('unindexed-record-search5', 'unindexed-record-doc-disp-pg');

      if (window.location.pathname.includes('unindexed-record-search1')) {
        thisURL = window.location.pathname.replace('unindexed-record-search1', 'unindexed-record-doc-disp-pg');
      } else if (window.location.pathname.includes('unindexed-record-search2')) {
        thisURL = window.location.pathname.replace('unindexed-record-search2', 'unindexed-record-doc-disp-pg');
      } else if (window.location.pathname.includes('unindexed-record-search3')) {
        thisURL = window.location.pathname.replace('unindexed-record-search3', 'unindexed-record-doc-disp-pg');
      } else if (window.location.pathname.includes('unindexed-record-search4')) {
        thisURL = window.location.pathname.replace('unindexed-record-search4', 'unindexed-record-doc-disp-pg');
      } else {
        thisURL = window.location.pathname.replace('unindexed-record-search5', 'unindexed-record-doc-disp-pg');
      }

      console.log(window.location.href + window.location.host + window.location.protocol);
      console.log(window.location.pathname.replace('unindexed-record-search1', 'unindexed-record-doc-disp-pg'));
      console.log(`baserUrl: ${thisURL}`);

      var baseStr = thisURL.split("/");


      console.log(`baseStr[baseStr.length -1]: ${baseStr[baseStr.length - 1]}`);
      var urlFinally = "";
      baseStr.forEach((s, i) => {
        if (i != baseStr.length - 1) {
          urlFinally += s + "/";
        }
      });
            
      let url = this.router.createUrlTree([urlFinally, e.itemData.indexBook, e.itemData.indexGroup, e.itemData.indexPage, e.itemData.dateGroup]);
      let urlSTR = url.toString();
      //let url = this.router.createUrlTree([bs, e.itemData.indexBook, e.itemData.indexGroup, e.itemData.indexPage, e.itemData.dateGroup]);

      let loc = localStorage.getItem("machineLocation")

      if (loc == '1') {
        var params = [
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');

        var popup = window.open(urlSTR, 'popup_window', params);
        popup.moveTo(0, 0);
      } else {
        window.open(urlSTR, '_blank');
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

}
